/*
 * @Author: mayanxia 
 * @Date: 2020-11-17 20:47:19 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-03-02 16:55:20
 */

<template>
  <a-modal
    :width="modalWidth"
    :visible="visible"
    :title="$t('区域搜索')"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
    wrapClassName="ant-modal-cust-warp"
    >
    <!--部门树-->
    <template>
      <a-form :form="form" style="max-height: 60vh;overflow: scroll">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('区域')">
      <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" :placeholder="$t('请输入区域名称')" />
      <!-- <a-tree
        checkable
        treeCheckable="tree"
        :defaultExpandAll="true"
        :checkStrictly="checkStrictly"
        @expand="onExpand"
        :checkedKeys="checkedKeys"
        :expandedKeys="expandedKeys"
        @check="onCheck"
        :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
        :treeData="areaTree"
        placeholder="请选择上级区域"
        >
      </a-tree> -->
      <el-tree
        class="filter-tree"
        show-checkbox
        :data="areaTree"
        :props="defaultProps"
        :expand-on-click-node="false"
        :filter-node-method="filterNode"
        :check-on-click-node="true"
        :check-strictly="checkStrictly"
        :highlight-current="true"
        node-key="id"
        :current-node-key="currentNodeKey"
        :default-checked-keys="checkedKeys"
        :default-expanded-keys="iExpandedKeys"
        :default-expand-all="false"
        :render-after-expand="false"
        @check-change="onEleCheck"
        ref="areaTree">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="tree-node-title">{{ node.label }}</span>
        </span>
      </el-tree>
      </a-form-item>
      </a-form>
    </template>
  </a-modal>
</template>

<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  export default {
    name: "areaWindow",
    mixins: [AreaChoosetMixin],
    components: {
    },
    props: {
      // checkStrictly: {
      //   type: Boolean,
      //   default: false
      // }
    },
    data () {
      return {
        checkedKeys:[], // 存储选中的部门id
        halfCheckedKeys:[],
        areaNameList: [],
        expandedKeys:[],//展开的节点
        userId:"", // 存储用户id
        model:{}, // 存储SysUserDepartsVO表
        modalWidth:400,
        areaTree:[],
        visible: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        headers:{},
        form:this.$form.createForm(this),
        url: {
          userId:"/sys/user/generateUserId", // 引入生成添加用户情况下的url
        },
        allTreeKeys: [],
        searchAreaValue: '',
        defaultProps: {
          children: 'children',
          label: 'areaName'
        },
        iExpandedKeys: []
      }
    },
    computed: {
      // i18n：标题使用 computed 以响应语言切换
      title () {
        return this.$t('操作')
      },
    },
    methods: {
      add (checkedAreaKeys,halfCheckedKeys,treeData,checkedAreaNames,userId) {
        if(treeData.length>0) {
          treeData.forEach(item => {
            this.getAllKeys(item);
            this.iExpandedKeys.push(item.id)
          })
        }
        this.areaNameList = checkedAreaNames;
        this.checkedKeys = checkedAreaKeys;
        this.halfCheckedKeys = halfCheckedKeys;
        this.userId = userId;
        this.areaTree = treeData
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.visible = true;
        this.model = Object.assign({}, record);
        let filedsVal = pick(this.model,'id','userId','areaIdList');
        this.$nextTick(() => {
          this.form.setFieldsValue(filedsVal);
        });
        console.log(this.checkedKeys)
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.checkedKeys = [];
        this.halfCheckedKeys = [];
        this.areaNameList = [];
      },
      handleSubmit () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err) => {
          if (!err) {
            that.confirmLoading = true;
            // let formData = {userId:this.userId,
            //   areaNameList: that.areaNameList,
            //   checkedKeys:that.checkedKeys,
            //   halfCheckedKeys: that.halfCheckedKeys}
            let checkedNodes = this.$refs.areaTree.getCheckedNodes();
            let areaNameList = [];
            for(let i=0;i<checkedNodes.length;i++) {
              areaNameList.push(checkedNodes[i].areaName)
            }
            let formData = {userId:this.userId,
              areaNameList: areaNameList,
              checkedKeys:that.$refs.areaTree.getCheckedKeys(),
              halfCheckedKeys: that.$refs.areaTree.getHalfCheckedKeys()}
            that.$emit('ok', formData);
            that.confirmLoading = false;
            that.close();
          }
        })
      },
      handleCancel () {
        this.close()
      },
      expandAll () {
        this.expandedKeys = this.allTreeKeys
      },
      getAllKeys(node) {
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }else{
          this.expandAll()
        }
      },
      // 选择部门时作用的API
      onCheck(checkedKeys, info){
        console.log(checkedKeys)
        console.log(info)
        this.areaNameList = []
        let checkedNodes = info.checkedNodes;
        if(this.checkStrictly) {
          this.checkedKeys = checkedKeys.checked;
          this.halfCheckedKeys = checkedKeys.halfChecked
        }else{
          this.checkedKeys = checkedKeys;
          this.halfCheckedKeys = info.halfCheckedKeys
        }
        for (let i = 0; i < checkedNodes.length; i++) {
          let data = checkedNodes[i].data.props;
          this.areaNameList.push(data.title);
        }
      },
      onExpand(expandedKeys){
        this.expandedKeys = expandedKeys;
      },
      nodeClick(record,node,data) {
        console.log("点击事件")
        // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
        if(node.checked) {
          this.checkedKeys = record.id
          this.$refs.areaTree.setCheckedKeys([record.id])
          //this.$refs.areaTree.setCurrentKey(record.id)
          this.currSelected = Object.assign({}, record);
          this.model.areaParentId = record.areaParentId
          this.setValuesToForm(record)
        }else{
          this.checkedKeys = null
          this.currSelected = {};
        }
      },
      onEleCheck(record,bool,node){
        // if(bool){
        //   this.checkedKeys.push(record.id);
        //   this.areaNameList.push(record.areaName);
        // }else{
        //   this.checkedKeys = this.checkedKeys.filter(item=> item !==record.id)
        //   this.areaNameList = this.areaNameList.filter(item=> item !==record.areaName)
        // }
      }
    },
  }
</script>

<style scoped>
  .ant-table-tbody .ant-table-row td{
    padding-top:10px;
    padding-bottom:10px;
  }
</style>